import { bus_bangkiemtuanthu, BusBangKiemTuanThuItemResponse } from "../../../models/response/bus/bus_bangkiemtuanthu";
import {
	eBusBangKiemTuanThuActionTypeIds,
	IBusBangKiemTuanThuChangeSelectedIds,
	IBusBangKiemTuanThuCloseConfirm,
	IBusBangKiemTuanThuCloseDetail,
	IBusBangKiemTuanThuDeleteErr,
	IBusBangKiemTuanThuDeleteStart,
	IBusBangKiemTuanThuDeleteSuccess,
	IBusBangKiemTuanThuLoadErr,
	IBusBangKiemTuanThuLoadStart,
	IBusBangKiemTuanThuLoadSuccess,
	IBusBangKiemTuanThuSaveErr,
	IBusBangKiemTuanThuSaveStart,
	IBusBangKiemTuanThuSaveSuccess,
	IBusBangKiemTuanThuShowConfirm,
	IBusBangKiemTuanThuShowDetail
} from "../../action-types/bus/IBusBangKiemTuanThuActionTypes";

export const busBangKiemTuanThuActions = {
	loadBusBangKiemTuanThuStart: (dm_coso_id: number): IBusBangKiemTuanThuLoadStart => {
		return {
			type: eBusBangKiemTuanThuActionTypeIds.LOAD_START,
			payload: dm_coso_id
		}
	},
	loadBusBangKiemTuanThuSuccess: (data: BusBangKiemTuanThuItemResponse[]): IBusBangKiemTuanThuLoadSuccess => {
		return {
			type: eBusBangKiemTuanThuActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadBusBangKiemTuanThuError: (message: string): IBusBangKiemTuanThuLoadErr => {
		return {
			type: eBusBangKiemTuanThuActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	showBusBangKiemTuanThuDetail: (data?: bus_bangkiemtuanthu): IBusBangKiemTuanThuShowDetail => {
		return {
			type: eBusBangKiemTuanThuActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeBusBangKiemTuanThuDetail: (): IBusBangKiemTuanThuCloseDetail => {
		return {
			type: eBusBangKiemTuanThuActionTypeIds.CLOSE_DETAIL
		}
	},
	showBusBangKiemTuanThuConfirm: (): IBusBangKiemTuanThuShowConfirm => {
		return {
			type: eBusBangKiemTuanThuActionTypeIds.SHOW_CONFIRM
		}
	},
	closeBusBangKiemTuanThuConfirm: (): IBusBangKiemTuanThuCloseConfirm => {
		return {
			type: eBusBangKiemTuanThuActionTypeIds.CLOSE_CONFIRM
		}
	},
	changeBusBangKiemTuanThuSelectedIds: (ids: number[]): IBusBangKiemTuanThuChangeSelectedIds => {
		return {
			type: eBusBangKiemTuanThuActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	deleteBusBangKiemTuanThuStart: (id: number): IBusBangKiemTuanThuDeleteStart => {
		return {
			type: eBusBangKiemTuanThuActionTypeIds.DELETE_START,
			payload: id
		}
	},
	deleteBusBangKiemTuanThuSuccess: (): IBusBangKiemTuanThuDeleteSuccess => {
		return {
			type: eBusBangKiemTuanThuActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteBusBangKiemTuanThuErr: (message: string): IBusBangKiemTuanThuDeleteErr => {
		return {
			type: eBusBangKiemTuanThuActionTypeIds.DELETE_ERROR,
			payload: message
		}
	},
	saveBusBangKiemTuanThuStart: (data: bus_bangkiemtuanthu): IBusBangKiemTuanThuSaveStart => {
		return {
			type: eBusBangKiemTuanThuActionTypeIds.SAVE_START,
			payload: data
		}
	},
	saveBusBangKiemTuanThuSuccess: (): IBusBangKiemTuanThuSaveSuccess => {
		return {
			type: eBusBangKiemTuanThuActionTypeIds.SAVE_SUCCESS
		}
	},
	saveBusBangKiemTuanThuError: (message: string): IBusBangKiemTuanThuSaveErr => {
		return {
			type: eBusBangKiemTuanThuActionTypeIds.SAVE_ERR,
			payload: message
		}
	}
}
